module.exports = __webpack_public_path__ + "img/ai_help01_img_01.b2e8f22c.png";